import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { fetchCustomerSatisfaction } from '@/redux/dashboard/getCustomerSatisfaction/customerSatisfactionSlice';

const ITEMS = [
  { key: 'postpartumCare', label: '产康', color: '#a78bfa' },
  { key: 'salesCustomerService', label: '客服', color: '#fbbf24' },
  { key: 'security', label: '安保', color: '#00e5ff' },
  { key: 'catering', label: '餐饮', color: '#00d4aa' },
  { key: 'housekeeping', label: '客房', color: '#f472b6' },
  { key: 'medicalTeam', label: '医疗', color: '#ff6b6b' }
];

function readScore(raw) {
  if (raw == null || raw === '') return null;
  const n = Number(raw);
  if (!Number.isFinite(n)) return null;
  return n;
}

function CustomerSatisfaction({ storeId }) {
  const dispatch = useDispatch();
  const customerSatisfaction = useSelector((state) => state.dashboard?.customerSatisfaction);
  const selectedStoreId = storeId != null && String(storeId).trim() !== '' ? String(storeId).trim() : '';
  const today = dayjs().format('YYYY-MM-DD');

  useEffect(() => {
    if (!selectedStoreId) return undefined;
    dispatch(fetchCustomerSatisfaction({
      query: { store_id: selectedStoreId, date: today }
    })).unwrap().catch(() => {});
    return undefined;
  }, [dispatch, selectedStoreId, today]);

  const sameStore = String(customerSatisfaction?.query?.store_id ?? '') === selectedStoreId;
  const data = sameStore && customerSatisfaction?.data && typeof customerSatisfaction.data === 'object'
    ? customerSatisfaction.data
    : {};
  const overall = readScore(data.overallSatisfaction);
  const barWidth = overall == null ? 0 : Math.max(0, Math.min(100, overall));

  return (
    <div className="customer-satisfaction">
      <div className="item-corner-tl"></div>
      <div className="item-corner-tr"></div>
      <div className="item-corner-bl"></div>
      <div className="item-corner-br"></div>

      <div className="cs-header">
        <span className="cs-title">客户满意度</span>
        <div className="cs-live-dot"></div>
      </div>

      <div className="cs-layout">
        <div className="cs-score-column">
          <div className="cs-score">
            <span className="cs-score-num">{overall == null ? '--' : Math.round(overall)}</span>
            <span className="cs-score-unit">%</span>
          </div>
        </div>
        <div className="cs-right-column">
          <div className="cs-score-bar">
            <div
              className="cs-score-fill"
              style={{
                width: `${barWidth}%`,
                background: 'linear-gradient(90deg, #00d4aa, #00e5ff)',
                boxShadow: '0 0 15px rgba(0, 212, 170, 0.6)'
              }}
            >
              <div className="cs-bar-shine"></div>
            </div>
          </div>
          <div className="cs-breakdown">
            {ITEMS.map((item) => {
              const score = readScore(data[item.key]);
              return (
                <div className="cs-item" key={item.key}>
                  <span className="cs-item-dot" style={{ background: item.color }}></span>
                  <span className="cs-item-label">{item.label}</span>
                  <span className="cs-item-value">{score == null ? '--' : Math.round(score)}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerSatisfaction;
